
import { AfterViewInit, Component, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { LangChangeEvent, TranslatePipe, TranslateService } from "@ngx-translate/core";
import { WcmService } from "@shared/services/wcm/wcm.service";
import { SharedModule } from "@shared/shared.module";

@Component({
	template: '<section class="pt-4 px-2 px-lg-0"><h2>{{ "footer.accessibility" | translate }}</h2><div class="free-text-page pt-3" [innerHTML]="accessibility"></div></section>',
	imports: [
		SharedModule,
		TranslatePipe
	],
	styleUrl: "./accessibility.component.scss",
})
export class AccessibilityComponent implements AfterViewInit {
	protected accessibility = "";
	// market: any;
	wcmService = inject(WcmService);

	translate = inject(TranslateService);
	constructor() {
		this.translate.onLangChange
			.pipe(takeUntilDestroyed())
			.subscribe(
				(event: LangChangeEvent) => {
					this.setData(event.lang);
				}
			);
	}
	private setData(lang: string) {
		this.wcmService.getDocument("accessibility", lang)
			.subscribe({
				next: value => {
					this.accessibility = value;
				},
				error: () => { this.accessibility = ""; }
			});
	}
	ngAfterViewInit() {
		this.setData(this.translate.getCurrentLang());
	}
}